import { render, staticRenderFns } from "./CapacitacionExterna.vue?vue&type=template&id=2e324c5a&scoped=true"
import script from "./CapacitacionExterna.vue?vue&type=script&lang=js"
export * from "./CapacitacionExterna.vue?vue&type=script&lang=js"
import style0 from "./CapacitacionExterna.vue?vue&type=style&index=0&id=2e324c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e324c5a",
  null
  
)

export default component.exports